<template>
  <div>
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import SmoothScroll from "smooth-scroll"
import { messaging } from "./init-fcm"
import { mapGetters } from "vuex"
const defaultLayout = "default"

export default {
  name: "App",
  computed: {
    /**
     * Gets layout component based on route meta data
     * @returns {string}
     */
    layout() {
      return `${this.$route.meta.layout ?? defaultLayout}-layout`
    },
    ...mapGetters({
      /**
       * Gets currently signed in user
       * @returns user
       */
      getCurrentUser: "getCurrentUser"
    })
  },
  async mounted() {
    new SmoothScroll('a[href*="#"]')
    //Need user to be signed in to get their uid
    if (messaging && this.getCurrentUser) {
      try {
        await messaging.requestPermission()
        const token = await messaging.getToken()

        const url = `${process.env.VUE_APP_PUSH_TOKEN_HTTPS}?token=${token}&userId=${this.getCurrentUser?.id}`
        fetch(url, { method: "POST" })
      } catch (error) {
        console.log("Permission was denied.")
      }
    }
  }
}
</script>
<style>
@import "./assets/styles/lite-blue.min.css";
@import "./assets/styles/custom.css";

body::-webkit-scrollbar {
  width: 0.45rem;
}

body::-webkit-scrollbar-track {
  background: rgb(41, 41, 41);
}

body::-webkit-scrollbar-thumb {
  background: var(--blue);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.main-header {
  z-index: 0 !important;
}
</style>
